import React, { useRef, useState } from "react"
import { useAuth } from '../../../contexts/AuthContext';
import styles from './Dashboard.module.scss';

export default function ChangeEmailForm({ currentEmail, onSaved }) {
    const emailRef = useRef();
    const codeRef = useRef();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [pending, setPending] = useState(null); // { email, changeToken }
    const { requestEmailChange, confirmEmailChange } = useAuth();

    async function handleRequestSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const newEmail = emailRef.current.value.trim();
            const result = await requestEmailChange(newEmail);
            if (!result.success) {
                setError(result.error);
            } else {
                setPending({ email: result.pendingEmail, changeToken: result.changeToken });
            }
        } catch (err) {
            setError('Failed to request email change');
        } finally {
            setLoading(false);
        }
    }

    async function handleConfirmSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const result = await confirmEmailChange(pending.changeToken, codeRef.current.value.trim());
            if (!result.success) {
                setError(result.error);
            } else {
                setPending(null);
                onSaved?.();
            }
        } catch (err) {
            setError('Failed to confirm email change');
        } finally {
            setLoading(false);
        }
    }

    function handleCancel() {
        // Nothing was ever saved server-side for a pending change, so cancelling here
        // just discards the ticket held in memory - the account's email never moved.
        setPending(null);
        setError('');
    }

    if (pending) {
        return (
            <>
                {error && <div className={styles.error}>{error}</div>}
                <p className={styles.pendingNote}>
                    We sent a 6-digit code to <strong>{pending.email}</strong>. Enter it below to confirm the
                    change, it expires in 10 minutes and your current email stays active until you do.
                </p>
                <form onSubmit={handleConfirmSubmit}>
                    <label>Verification code</label>
                    <input
                        key="code"
                        ref={codeRef}
                        type="text"
                        inputMode="numeric"
                        pattern="\d{6}"
                        maxLength={6}
                        placeholder="123456"
                        autoFocus
                        required
                    />
                    <div className={styles.formActions}>
                        <button type="submit" className={styles.button} disabled={loading}>
                            {loading ? 'Saving...' : 'Save'}
                        </button>
                        <button type="button" className={styles.button} onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                </form>
            </>
        )
    }

    return (
        <>
            {error && <div className={styles.error}>{error}</div>}
            <form onSubmit={handleRequestSubmit}>
                <label>New email</label>
                <input key="email" ref={emailRef} type="email" defaultValue={currentEmail} required autoFocus/>
                <button type="submit" className={styles.button} disabled={loading}>
                    {loading ? 'Saving...' : 'Save'}
                </button>
            </form>
        </>
    )
}
